import { Stack } from '@mui/material';

import { Logo } from './styled';

function Header() {
  return (
    <Stack
      direction="column"
      justifyContent="start"
      alignItems="start"
      gap={8}
      px={5}
      pt={12}
      pb={5}
    >
      <Logo src="/static/logos/NewBasetenLogo.svg" />
    </Stack>
  );
}

export default Header;
